<!--
 * @Author: van
 * @Date: 2021-09-27 16:21:49
 * @LastEditors: van
 * @LastEditTime: 2021-10-07 11:19:43
-->
<template>
    <el-dialog
        class="shopify-listing-detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1400px"
        :title="$t('goodsList.shopifyListing.dialogTitle')"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container" v-loading="loading">
            <el-form ref="listingForm" :model="listingForm" label-width="110px" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="12">
                        <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.shop')"
                                prop="shop_id"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t('goodsList.shopifyListing.shop')}`"
                                    maxlength="200"
                                    size="small"
                                    v-model="listingForm.shop_name"
                                    :readonly="readonly"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="
                                    $t('goodsList.shopifyListing.goods_name')
                                "
                                prop="goods_name"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t(
                                        'goodsList.shopifyListing.goods_name'
                                    )}`"
                                    maxlength="200"
                                    size="small"
                                    v-model="listingForm.goods_name"
                                    :readonly="readonly"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.category')"
                                prop="category"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.category_name"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t(
                                        'goodsList.shopifyListing.category'
                                    )}`"
                                    :readonly="readonly"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="SPU" prop="spu" size="small">
                                <el-input
                                    clearable
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}SKU`"
                                    maxlength="200"
                                    size="small"
                                    v-model="listingForm.spu"
                                    :readonly="readonly"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="ItemID" size="small">
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.itemID"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t(
                                        'goodsList.shopifyListing.barcode'
                                    )}`"
                                    :readonly="readonly"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.tags')"
                                size="small"
                            >
                                <tagsInput
                                    :tagsList.sync="listingForm.tags"
                                    :title="$t('goodsList.shopifyListing.tags')"
                                    :visible="detailVisible"
                                    :disabled="true"
                                ></tagsInput>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.keyword')"
                                size="small"
                            >
                                <tagsInput
                                    :tagsList.sync="listingForm.keyword"
                                    :title="
                                        $t('goodsList.shopifyListing.keyword')
                                    "
                                    :visible="detailVisible"
                                    :disabled="true"
                                ></tagsInput>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="$t('goodsList.shopifyListing.vendor')"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.vendor"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t('goodsList.shopifyListing.vendor')}`"
                                    :readonly="readonly"
                                ></el-input>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="24">
                            <el-form-item
                                :label="
                                    $t(
                                        'goodsList.shopifyListing.published_scope'
                                    )
                                "
                                size="small"
                                :label-width="
                                    $i18n.locale == 'zh' ? '100px' : '110px'
                                "
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.published_scope"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t(
                                        'goodsList.shopifyListing.published_scope'
                                    )}`"
                                    :readonly="readonly"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                :label="
                                    $t(
                                        'goodsList.shopifyListing.listing_status'
                                    )
                                "
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="listingForm.status_name"
                                    :placeholder="`${$t(
                                        'goodsList.shopifyListing.inputPlaceholder'
                                    )}${$t(
                                        'goodsList.shopifyListing.listing_status'
                                    )}`"
                                    :readonly="readonly"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Picture" size="small">
                            <!-- <imgUpload
                                :images="listingForm.goods_images"
                                ref="uploadsRef"
                                @imagesChange="imagesChange"
                                :multiple="true"
                            /> -->
                            <div class="picture-items">
                                <div
                                    class="picture-item"
                                    v-for="item of listingForm.goods_images"
                                    :key="item"
                                >
                                    <el-image :src="item" :preview-src-list="listingForm.goods_images"></el-image>
                                </div>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            :label="$t('goodsList.shopifyListing.goods_desc')"
                            size="small"
                        >
                            <vue-tinymce
                                v-model="listingForm.goods_desc"
                                :setting="setting"
                                v-if="detailVisible"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="table">
                            <el-table
                                border
                                :data="listingForm.attribute"
                                ref="attribute"
                                highlight-current-row
                                max-height="500px"
                            >
                                <el-table-column
                                    label="Images"
                                    align="center"
                                    width="80"
                                >
                                    <template slot-scope="scope">
                                        <el-image
                                            style="width: 60px; height: 60px"
                                            class="elImage_show"
                                            :src="scope.row.attr_image[0]"
                                            fit="contain"
                                            @click="updateImg(scope)"
                                        >
                                            <div
                                                slot="error"
                                                class="image-slot"
                                            >
                                                <i
                                                    class="
                                                        el-icon-picture-outline
                                                    "
                                                ></i>
                                            </div>
                                            <div
                                                slot="placeholder"
                                                class="image-slot"
                                            >
                                                <i class="el-icon-loading"></i>
                                            </div>
                                        </el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="SKU"
                                    align="center"
                                    width="120"
                                    prop="sku"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="ItemID"
                                    align="center"
                                    prop="itemID"
                                    width="120"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="Name"
                                    align="center"
                                    prop="name"
                                    width="220"
                                    show-overflow-tooltip
                                >
                                </el-table-column>
                                <el-table-column
                                    label="Price"
                                    align="center"
                                    prop="price"
                                    width="140"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="Stock"
                                    align="center"
                                    prop="stock"
                                    width="120"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="Value"
                                    align="center"
                                    prop="attr_value"
                                    show-overflow-tooltip
                                >
                                </el-table-column>
                                <!-- <el-table-column
                                    align="center"
                                    :label="
                                        $t('goodsList.shopifyListing.operation')
                                    "
                                    :key="item"
                                    width="100"
                                >
                                    <template slot-scope="scope">
                                        <el-button
                                            type="text"
                                            icon="el-icon-minus"
                                            style="color: red"
                                            @click="
                                                minusItem_attributeTable(scope)
                                            "
                                        ></el-button>
                                    </template>
                                </el-table-column> -->
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >{{ $t("goodsList.shopifyListing.save") }}</el-button
            > -->
            <el-button size="small" @click="detailVisible = false">
                {{ $t("goodsList.shopifyListing.close") }}
            </el-button>
        </span>
        <updateImg
            :updateImgVisible.sync="updateImgVisible"
            :tableItemIndex.sync="tableItemIndex"
            :imagesList="imagesList"
            @imgUrl="imgUrl"
            :type="'detail'"
        ></updateImg>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState } from "vuex";
import updateImg from "./updateImg";
import tagsInput from "@/common/components/tags-input";
import imgUpload from "components/imgUpload";
export default {
    data() {
        return {
            oldAttribute: [],
            listingForm: {
                goods_name: "", //产品名称
                goods_desc: "", // 产品描述
                category: "", // 产品分类
                category_id: "",
                keyword: [], // 关键字
                sku: "", // 产品sku
                barcode: "", // 产品条码
                tags: [], // 标签
                goods_images: [], // 刊登图片
                attribute: [
                    {
                        images: [], // 产品图片
                        sku: "", //属性sku
                        name: "", //属性名称
                        value: "", // 属性值
                        upc: "", // 多属性产品条码
                        hscode: "", // 海关hs号
                        price: "", // 价格
                        stock: "", // 库存
                        currency: "", //货币
                    },
                ],
                type: 1, //类型1-单品 2-多属性
                platform_id: "",
                shop_id: "",
                listing_status: "draft",
                // product_type: "",
                vendor: "",
                published_scope: "",
            },
            published_scopeList: ["web", "global"],
            imagesList: [],
            updateImgVisible: false,
            tableItemIndex: "",
            emptyTableItem: {
                images: [], // 产品图片
                sku: "", //属性sku
                name: "", //属性名称
                upc: "", // 多属性产品条码
                hscode: "", // 海关hs号
                price: "", // 价格
                stock: "", // 库存
                currency: "", //货币
            },
            shopList: [],
            tabName: "1",
            loading: false,
            readonly: true,
        };
    },
    methods: {
        imagesChange(images) {
            this.listingForm.goods_images = images;
        },
        save() {
            this.$refs["listingForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .singlePublication(
                            {
                                ...this.listingForm,
                                goods_id: this.listingForm.id,
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success("Product Publishing Done.");
                                // this.$parent.getGoodsList();
                                this.loading = false;
                                this.closeDialog();
                            } else {
                                this.$message.error("Publish failed, please contact our support with screenshots or product link.")
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
        closeDialog() {
            this.listingForm = {
                goods_name: "", //产品名称
                goods_desc: "", // 产品描述
                category: "", // 产品分类
                category_id: "",
                keyword: [], // 关键字
                sku: "", // 产品sku
                barcode: "", // 产品条码
                tags: [], // 标签
                goods_images: [], // 刊登图片
                attribute: [
                    {
                        images: [], // 产品图片
                        sku: "", //属性sku
                        name: "", //属性名称
                        value: "", // 属性值
                        upc: "", // 多属性产品条码
                        hscode: "", // 海关hs号
                        price: "", // 价格
                        stock: "", // 库存
                        currency: "", //货币
                    },
                ],
                type: 1, //类型1-单品 2-多属性
                platform_id: "",
                shop_id: "",
                listing_status: "draft",
                // product_type: "",
                vendor: "",
                published_scope: "",
            };
            this.tabName = "1";
            this.$refs["listingForm"].clearValidate();
            this.$refs["listingForm"].resetFields();
            this.$emit("update:detailVisible", false);
        },
        updateImg(scope) {
            this.imagesList = scope.row.images;
            this.updateImgVisible = true;
            this.tableItemIndex = scope.$index;
        },
        imgUrl(params) {
            this.listingForm.attribute[this.tableItemIndex].images = params;
        },
        minusItem_attributeTable(scope) {
            if (this.listingForm.attribute.length > 1) {
                for (let i in this.listingForm.attribute) {
                    if (i == scope.$index) {
                        this.listingForm.attribute.splice(i, 1);
                    }
                }
            } else {
                return false;
            }
        },
        typeChange(val) {
            if (val == 1 && this.listingForm.attribute.length > 1) {
                this.oldAttribute = JSON.parse(
                    JSON.stringify(this.listingForm.attribute)
                );
                this.listingForm.attribute.splice(
                    1,
                    this.listingForm.attribute.length - 1
                );
            } else if (val == 2 && this.oldAttribute.length > 1) {
                for (let i = 1; i < this.oldAttribute.length; i++) {
                    this.listingForm.attribute.push(this.oldAttribute[i]);
                }
            }
        },
        currencySelect() {
            cmofferApi.currencySelect({}, "get").then((res) => {
                if (res) {
                    this.currencyList = res.data;
                }
            });
        },
        getGoodsList() {
            cmofferApi
                .shopifyListing({}, "get", this.tableItem.id)
                .then((res) => {
                    console.log("res: ", res);
                    if (res) {
                        this.listingForm = {
                            ...res.data,
                            attribute: res.data.shopify_listing_attr,
                            /* platform_id: "",
                            shop_id: "",
                            listing_status: "draft",
                            goods_images: res.data.goods_images, // 刊登图片
                            sku: res.data.spu,
                            category: res.data.goods_category.name_en,
                            type: res.data.goods_attribute.length <= 1 ? 1 : 2, //类型1-单品 2-多属性 */
                        };
                        this.loading = false;
                    }
                });
        },

        shopSelect() {
            cmofferApi
                .shopSelect({ platform_id: this.platform_id }, "get")
                .then((res) => {
                    if (res) {
                        this.shopList = res.data;
                    }
                });
        },
    },
    components: {
        imgUpload,
        updateImg: updateImg,
        tagsInput: tagsInput,
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
        platform_id: Number,
    },
    computed: {
        ...mapState({
            setting: (state) =>
                Object.assign(JSON.parse(JSON.stringify(state.index.setting)), {
                    height: 400,
                    toolbar: false,
                    readonly: true,
                }),
        }),
    },
    watch: {
        detailVisible(val) {
            if (val) {
                this.loading = true;
                this.shopSelect();
                this.currencySelect();
                this.getGoodsList();
            }
        },
    },
};
</script>
<style lang="scss">
.shopify-listing-detail {
    .container {
        width: 100%;
        .el-upload--picture-card {
            float: left !important;
            margin-right: 10px;
        }
        .uploadBox {
            .el-upload,
            .el-upload--text {
                width: 100%;
                height: 100%;
            }
        }
        .picture-items {
            display: flex;
            flex-wrap: wrap;
            .picture-item {
                margin: 10px 10px 0 0;
                border: 1px solid #ddd;
                border-radius: 0;
                position: relative;
                overflow: hidden;
                text-align: center;
                width: 100px;
                height: 100px;
                .el-image {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .describeContent {
            line-height: 1.6;
        }
        .addAttribute {
            color: $color-primary;
            text-align: left;
        }
        .table {
            .el-form-item {
                margin: 0;
            }
        }
    }
    .el-select--small {
        width: 100%;
    }
}
</style>
